<template>
  <div class="secondary-title" :class="align">
    <component :is="tag">
      <slot />
    </component>
  </div>
</template>

<style lang="scss" scoped>
@import "@/_shared/scss/saas/_title-style.scss";
</style>

<script>
export default {
  props: {
    tag: {
      type: String,
      default: "h4",
    },
    align: {
      type: String,
      default: "left",
    },
  },
};
</script>
